import { render, staticRenderFns } from "./doQuestionRecord.vue?vue&type=template&id=6cb7eb54&scoped=true"
import script from "./doQuestionRecord.vue?vue&type=script&lang=js"
export * from "./doQuestionRecord.vue?vue&type=script&lang=js"
import style0 from "./doQuestionRecord.vue?vue&type=style&index=0&id=6cb7eb54&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb7eb54",
  null
  
)

export default component.exports